import { defineEffect } from '../../../core/effect';

/**
 * **セット**（Issue #529。索引 #525。**最初の 1 本**）。
 *
 * 開く: `set`。伏せたカードのゾーンに、青い衝撃の輪が広がって消える ＋ 芯の光。
 * 閉じる: 尺で閉じる（`duration` を返さないので、器が**最後のキー**から測る）。
 *
 * **宣言だけで書けるか**を確かめるための 1 本なので、素材は `ring` と `glow` だけを使う。
 * 実写でも仮想フィールドでも同じ —— Field がゾーンの場所を答えるので、演出は差を知らない
 * （旧 `components/fx` では `inVirtualScene` の分岐が要っていた）。
 */
const COLOR = '#3fd0ff';

export default defineEffect({
  situation: 'set',
  label: 'セット',
  color: COLOR,
  sounds: () => [{ at: 220, name: 'set_card' }],   // カードが置かれる瞬間

  /** 置かれた場所が分からないイベントでは出さない */
  opens({ payload }) {
    return payload?.zone ? payload : null;
  },

  layers: [
    /*
     * **芯の光**。置かれた瞬間（220ms）に強く光って引く。
     * `blend: 'add'` は素材の既定（透過のキャンバスで重なりが黒ずまないように）。
     */
    {
      id: 'flash',
      label: '芯の光',
      part: 'glow',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      tf: {
        scale: { keys: [{ ms: 160, value: 0.6 }, { ms: 260, value: 2.4, ease: 'ease_out' }, { ms: 620, value: 2.8 }] },
        opacity: { keys: [{ ms: 160, value: 0 }, { ms: 260, value: 0.95 }, { ms: 620, value: 0 }] },
      },
    },
    /*
     * **衝撃の輪**。芯より少し遅れて広がり、薄れながら止まる。
     * 回すのは器（`tf.rotation`）なので、素材は止まった 1 枚の絵だけを描く。
     */
    {
      id: 'shock',
      label: '衝撃の輪',
      part: 'ring',
      at: { card: '{uid}', else: { zone: '{zone}' } },
      tf: {
        scale: { keys: [{ ms: 220, value: 0.5 }, { ms: 560, value: 3.2, ease: 'ease_out' }, { ms: 900, value: 3.6 }] },
        opacity: { keys: [{ ms: 220, value: 0 }, { ms: 300, value: 0.85 }, { ms: 900, value: 0 }] },
        rotation: { keys: [{ ms: 220, value: -20 }, { ms: 900, value: 10 }] },
      },
    },
  ],
}, 'set_effect.js');
